import serialize from '../../general/serialize/serialize';
import serializeArray, { type TypeSerializedArray } from '../../general/serialize/serializeArray';
import serializeObject, { type TypeSerializedObject } from '../../general/serialize/serializeObject';

import * as exReset from './reset';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLFormElement {
        serialize(): string;
        serializeArray(): TypeSerializedArray;
        serializeObject(): TypeSerializedObject;
        reset(config: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLFormElement.prototype.serialize = function (): string {
    return serialize(this);
};

HTMLFormElement.prototype.serializeArray = function (): TypeSerializedArray {
    return serializeArray(this);
};

HTMLFormElement.prototype.serializeObject = function (): TypeSerializedObject {
    return serializeObject(this);
};

// ----------------------------------------------------------------------------

HTMLFormElement.prototype.reset = function (config: Record<string, any> = {}): void {
    exReset.general(this, config);
};
